import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[var(--line)] mt-20 bg-[var(--bg-2)]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9">
              <img
                src="/icons/promptdojo-mark.png?v=4"
                alt="PromptDojo"
                width={36}
                height={36}
                className="w-9 h-9 select-none"
                draggable="false"
              />
            </div>
            <span className="font-display text-2xl tracking-tight">PromptDojo</span>
          </div>
          <p className="text-sm text-[var(--ink-2)] mt-4 max-w-sm leading-relaxed">
            Use AI to make money, save time, and build things — five minutes a day.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.15em] text-[var(--ink-3)] font-bold mb-4">Product</div>
          <ul className="space-y-1 text-sm">
            <li><Link to="/pricing" className="inline-flex items-center min-h-[44px] py-2 text-[var(--ink-2)] hover:text-[var(--ink)] transition-colors" data-testid="footer-pricing-link">Pricing</Link></li>
            <li><Link to="/business" className="inline-flex items-center min-h-[44px] py-2 text-[var(--ink-2)] hover:text-[var(--ink)] transition-colors" data-testid="footer-teams-link">For teams</Link></li>
            <li><Link to="/contact" className="inline-flex items-center min-h-[44px] py-2 text-[var(--ink-2)] hover:text-[var(--ink)] transition-colors" data-testid="footer-contact-link">Contact</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.15em] text-[var(--ink-3)] font-bold mb-4">Legal</div>
          <ul className="space-y-1 text-sm">
            <li><Link to="/terms" className="inline-flex items-center min-h-[44px] py-2 text-[var(--ink-2)] hover:text-[var(--ink)] transition-colors" data-testid="footer-terms-link">Terms of Service</Link></li>
            <li><Link to="/privacy" className="inline-flex items-center min-h-[44px] py-2 text-[var(--ink-2)] hover:text-[var(--ink)] transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/refund" className="inline-flex items-center min-h-[44px] py-2 text-[var(--ink-2)] hover:text-[var(--ink)] transition-colors" data-testid="footer-refund-link">Refund Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--line)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[var(--ink-3)]">
          <div>© {new Date().getFullYear()} PromptDojo. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}
